import { useEffect, useState } from "react";
import close from "../../assets/images/close.svg";
import { Col, Form, Row } from "react-bootstrap";
import {
  commonservices,
  DAY_MAPPING,
  MONTH_MAPPING,
  TIMEZONE_LIST,
} from "../../services/CommonServices";
import Select from "react-select";
import infoIcon from "../../assets/images/infobtnblue.svg";
import { useDispatch, useSelector } from "react-redux";
import { GetWorkCronExpression } from "../../services/ReduxTookit/Slice/WorkFlowRedux";
import { toast } from "react-toastify";

function SchedularPopup({
  id,
  isViewMode,
  handleshowPopup,
  data,
  flowName,
  CronParseValues,
  handleSubmit,
  schedularData,
  FnForSetTrackState,
}) {
  let Userdata = useSelector((state) => state.userinfo.UserInfo);

  const dispatch = useDispatch();
  const [DayList, setDayList] = useState([]);

  const minuteOptions = [
    {
      label: "0",
      value: "0",
    },
    {
      label: "15",
      value: "15",
    },
    {
      label: "30",
      value: "30",
    },
    {
      label: "45",
      value: "45",
    },
  ];

  const dateOptions = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9", value: "9" },
    { label: "10", value: "10" },
    { label: "11", value: "11" },
    { label: "12", value: "12" },
    { label: "13", value: "13" },
    { label: "14", value: "14" },
    { label: "15", value: "15" },
    { label: "16", value: "16" },
    { label: "17", value: "17" },
    { label: "18", value: "18" },
    { label: "19", value: "19" },
    { label: "20", value: "20" },
    { label: "21", value: "21" },
    { label: "22", value: "22" },
    { label: "23", value: "23" },
    { label: "24", value: "24" },
    { label: "25", value: "25" },
    { label: "26", value: "26" },
    { label: "27", value: "27" },
    { label: "28", value: "28" },
    { label: "29", value: "29" },
    { label: "30", value: "30" },
    { label: "31", value: "31" },
  ];

  const [SelectedDayList, setSelectedDayList] = useState(
    schedularData?.["WorkFlowSchedule.weekdays"]
      ? schedularData?.["WorkFlowSchedule.weekdays"]?.split(",")
      : []
  );

  const [SelectedMonthList, setSelectedMonthList] = useState(
    schedularData?.["WorkFlowSchedule.schedulemonth"]
      ? schedularData?.["WorkFlowSchedule.schedulemonth"]
          ?.split(",")
          .map(Number)
      : []
  );

  const Hour_Options = [];
  Array(24)
    .fill("")
    ?.forEach((item, index) => {
      Hour_Options?.push({
        label: `${index}`,
        value: `${index}`,
      });
    });

  // let AllTimeZoneList = commonservices.getAllTimeZoneList();
  // const [AllTimeZoneOptions, setAllTimeZoneOptions] = useState([]);
  // const [SelectedTimeZone, setSelectedTimeZone] = useState({
  //   value: "",
  //   label: "",
  // });
  // useEffect(() => {
  //   if (AllTimeZoneList?.length > 0) {
  //     let temp = [];
  //     AllTimeZoneList.forEach((element) => {
  //       temp.push({ value: element, label: element });
  //     });
  //     setAllTimeZoneOptions(temp);
  //   }
  // }, []);

  // let YES_NO_ARRAY = ["Yes", "No"];
  const [MonthList, setMonthList] = useState([]);

  // const [Input, setInput] = useState({
  //   startdate: null,
  //   enddate: null,
  // });
  let minutes = [],
    hours = [],
    dates = [];
  if (
    schedularData?.["WorkFlowSchedule.minute"] &&
    !schedularData?.["filter.minute"]
  ) {
    schedularData?.["WorkFlowSchedule.minute"]?.split(",")?.forEach((item) => {
      minutes.push({
        label: `${item}`,
        value: `${item}`,
      });
    });
  }
  if (
    schedularData?.["WorkFlowSchedule.hour"] &&
    !schedularData?.["filter.hour"]
  ) {
    schedularData?.["WorkFlowSchedule.hour"]?.split(",")?.forEach((item) => {
      hours.push({
        label: `${item}`,
        value: `${item}`,
      });
    });
  }
  if (
    schedularData?.["WorkFlowSchedule.scheduledays"] &&
    !schedularData?.["filter.date"]
  ) {
    schedularData?.["WorkFlowSchedule.scheduledays"]
      ?.split(",")
      ?.forEach((item) => {
        dates.push({
          label: `${item}`,
          value: `${item}`,
        });
      });
  }

  const [errList, setErrList] = useState({
    minutes: false,
    hour: false,
    dates: false,
  });

  // Current Date :
  const currentDate = new Date();
  // Five years plus end-Date :
  const futureFiveYearsPlusDate = new Date(
    currentDate.setFullYear(currentDate.getFullYear() + 5)
  );

  let validationObj = {
    startdate: schedularData?.["WorkFlowSchedule.startondatetime"]
      ? schedularData?.["WorkFlowSchedule.startondatetime"]
      : id === "0"
      ? commonservices.getDateInDBFormat(new Date())
      : null,
    enddate: schedularData?.["WorkFlowSchedule.endondatetime"]
      ? schedularData?.["WorkFlowSchedule.endondatetime"]
      : id === "0"
      ? commonservices.getDateInDBFormat(futureFiveYearsPlusDate)
      : null,
    projectname: flowName ? flowName : "",
    timezone: schedularData?.["WorkFlowSchedule.timezone"]
      ? schedularData?.["WorkFlowSchedule.timezone"]
      : id === "0"
      ? Userdata.timezone
      : "",
    minute: minutes,
    hour: hours,
    date: dates,
    errors: {
      projectname: "",
      timezone: "",
      startdate: "",
      enddate: "",
      ValidationRules: [
        {
          FieldName: "projectname",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "timezone",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "startdate",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
        {
          FieldName: "enddate",
          ValidationType: "required",
          ValidationMessage: "This Field is a required field",
        },
      ],
    },
  };
  const [allFilter, setAllFilter] = useState({
    minute: schedularData?.["filter.minute"]
      ? schedularData?.["filter.minute"]
      : false,
    hour: schedularData?.["filter.hour"]
      ? schedularData?.["filter.hour"]
      : false,
    date: schedularData?.["filter.date"]
      ? schedularData?.["filter.date"]
      : false,
  });

  const [Input, setInput] = useState(validationObj);

  const [cronExpression, setCronExpression] = useState(
    schedularData?.["WorkFlowSchedule.cronexpression"]
      ? schedularData?.["WorkFlowSchedule.cronexpression"]
      : id === "0"
      ? "0 0 1 1 *"
      : ""
  );

  // useEffect(() => {
  //   if (Input?.timezone) {
  //     setSelectedTimeZone({
  //       value: Input?.timezone,
  //       label: Input?.timezone,
  //     });
  //   }
  // }, [Input]);

  const [activeTab, setActiveTab] = useState(id === "0" ? 1 : 0);
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  function fnDayHandle(e) {
    let { value, checked } = e.target;
    // const allDays = Object.values(DAY_MAPPING);
    let allDays = [];
    DayList?.forEach((item) => {
      allDays.push(DAY_MAPPING[item]);
    });
    if (value === "Every Day") {
      if (checked) {
        setSelectedDayList(allDays);
      } else {
        setSelectedDayList([]);
      }
    } else {
      const dayNumber = DAY_MAPPING[value];
      setSelectedDayList((prev) => {
        if (checked) {
          return [...new Set([...prev, dayNumber])];
        } else {
          return prev.filter((day) => day !== dayNumber);
        }
      });
    }
  }

  function fnMonthHandle(e) {
    let { value, checked } = e.target;

    // const allMonths = Object.values(MONTH_MAPPING);
    let allMonths = [];
    MonthList?.forEach((item) => {
      allMonths.push(parseInt(MONTH_MAPPING[item]) + 1);
    });
    if (value === "Every Month") {
      if (checked) {
        setSelectedMonthList(allMonths);
      } else {
        setSelectedMonthList([]);
      }
    } else {
      const monthNumber = parseInt(MONTH_MAPPING[value]) + 1;

      setSelectedMonthList((prev) => {
        if (checked) {
          return [...new Set([...prev, monthNumber])];
        } else {
          return prev.filter((month) => month !== monthNumber);
        }
      });
    }
  }
  // function fnRunRepHandle(e) {
  //   let { value, checked } = e.target;
  //   if (checked) {
  //     setInput({
  //       ...Input,
  //       run_repeatedly: value,
  //     });
  //   }
  // }
  // function fnEnableShedulingHandle(e) {
  //   let { value, checked } = e.target;
  //   if (checked) {
  //     setInput({
  //       ...Input,
  //       enable_scheduling: value,
  //     });
  //   }
  // }
  // function fnEnableExecutionHandle(e) {
  //   let { value, checked } = e.target;
  //   if (checked) {
  //     setInput({
  //       ...Input,
  //       enable_execution: value,
  //     });
  //   }
  // }

  const getCronExpression = async () => {
    let selectedMinutes = [],
      selectedHours = [],
      selectedDates = [];

    Input?.minute?.forEach((item) => {
      selectedMinutes?.push(item?.value);
    });
    Input?.hour?.forEach((item) => {
      selectedHours?.push(item?.value);
    });
    Input?.date?.forEach((item) => {
      selectedDates?.push(item?.value);
    });

    if (
      allFilter?.hour &&
      !allFilter?.minute &&
      selectedMinutes?.length === 0
    ) {
      selectedMinutes?.push("0");
    }
    if (allFilter?.date) {
      if (selectedHours?.length === 0 && !allFilter?.hour) {
        selectedHours?.push("1");
      }
      if (selectedMinutes?.length === 0 && !allFilter?.minute) {
        selectedMinutes?.push("0");
      }
    }

    if (
      (!allFilter?.minute && selectedMinutes?.length === 0) ||
      (!allFilter?.hour && selectedHours?.length === 0) ||
      (!allFilter?.date && selectedDates?.length === 0)
    ) {
      setErrList((prevErrList) => ({
        ...prevErrList,
        minutes: selectedMinutes?.length === 0,
        hour: selectedHours?.length === 0,
        dates: selectedDates?.length === 0,
      }));
    } else {
      let cronString = "";
      await dispatch(
        GetWorkCronExpression({
          StartDate: Input?.startdate,
          EndDate: Input?.enddate,
          Hour: allFilter?.hour ? "*" : selectedHours?.toString(),
          Minute: allFilter?.minute ? "*" : selectedMinutes?.toString(),
          Week:
            SelectedDayList?.length === 7 ? "*" : SelectedDayList?.toString(),
          localTimezoneId: Input?.timezone,
          monthday: allFilter?.date ? "*" : selectedDates?.toString(),
          months:
            SelectedMonthList?.length === 12
              ? "*"
              : SelectedMonthList?.toString(),
        })
      ).then((response) => {
        if (response?.payload?.isValidate) {
          cronString = response?.payload?.data?.data;
        } else {
          setCronExpression("");
        }
      });

      return cronString;
    }
  };

  const dayCreationFromDates = (startDate, endDate) => {
    let monthnamelist = [];
    let daynamelist = [];
    const date = new Date(new Date(startDate).getTime());
    let dates = [];
    while (date <= new Date(endDate)) {
      dates = [...dates, new Date(date)];
      date.setDate(date.getDate() + 1);
    }
    dates.forEach((d) => {
      const monthName = d.toLocaleString("default", {
        month: "long",
      });
      const dayName = d.toLocaleString("default", {
        weekday: "long",
      });
      if (!monthnamelist.includes(monthName)) {
        monthnamelist.push(monthName);
      }

      if (!daynamelist.includes(dayName)) {
        daynamelist.push(dayName);
      }
    });
    setDayList(daynamelist);
    setMonthList(monthnamelist);
  };

  useEffect(() => {
    if (Input?.startdate && Input?.enddate) {
      dayCreationFromDates(Input?.startdate, Input?.enddate);
    }
  }, [schedularData]);

  const handleMultiSelection = (selectedValue, tag) => {
    setInput({
      ...Input,
      [tag]: selectedValue,
    });

    if (tag === "minute" && errList.minutes) {
      setErrList((prevErrList) => ({
        ...prevErrList,
        minutes: false,
      }));
    }
    if (tag === "hour" && errList.hour) {
      setErrList((prevErrList) => ({
        ...prevErrList,
        hour: false,
      }));
    }
    if (tag === "date" && errList.dates) {
      setErrList((prevErrList) => ({
        ...prevErrList,
        dates: false,
      }));
    }
  };

  useEffect(() => {
    setAllFilter((prev) => ({
      ...prev,
      minute:
        Input?.minute?.length === minuteOptions?.length ? true : prev.minute,
      hour: Input?.hour?.length === Hour_Options?.length ? true : prev.hour,
      date: Input?.date?.length === dateOptions?.length ? true : prev.date,
    }));
  }, [Input, minuteOptions, Hour_Options, dateOptions]);

  const handleSubmitScheduler = async (e) => {
    FnForSetTrackState(true);
    let obj = commonservices.fnCheckValidationOfObject(Input);
    setInput({
      ...obj.obj,
    });

    if (obj.isValid) {
      if (activeTab === 0) {
        let cronString = await getCronExpression();

        let selectedMinutes = [],
          selectedHours = [],
          selectedDates = [];
        Input?.minute?.forEach((item) => {
          selectedMinutes?.push(item?.value);
        });
        Input?.hour?.forEach((item) => {
          selectedHours?.push(item?.value);
        });
        Input?.date?.forEach((item) => {
          selectedDates?.push(item?.value);
        });
        let obj = {
          "WorkFlowSchedule.timezone": Input?.timezone,
          "WorkFlowSchedule.startondatetime": Input?.startdate,
          "WorkFlowSchedule.endondatetime": Input?.enddate,
          "WorkFlowSchedule.scheduledays": allFilter?.date
            ? "all"
            : selectedDates?.toString(),
          "WorkFlowSchedule.schedulemonth": SelectedMonthList?.toString(),
          "WorkFlowSchedule.hour": allFilter?.hour
            ? "all"
            : selectedHours?.toString(),
          "WorkFlowSchedule.minute": allFilter?.minute
            ? "all"
            : selectedMinutes?.toString(),
          "WorkFlowSchedule.weekdays": SelectedDayList?.toString(),
          "WorkFlowSchedule.cronexpression": cronString,
          "filter.minute": allFilter?.minute,
          "filter.hour": allFilter?.hour,
          "filter.date": allFilter?.date,
        };
        if (cronString) {
          handleSubmit(obj);
          handleshowPopup(e);
        }
      } else {
        let obj = {
          "WorkFlowSchedule.timezone": Input?.timezone,
          "WorkFlowSchedule.startondatetime": Input?.startdate,
          "WorkFlowSchedule.endondatetime": Input?.enddate,
          "WorkFlowSchedule.scheduledays": "",
          "WorkFlowSchedule.schedulemonth": "",
          "WorkFlowSchedule.hour": "",
          "WorkFlowSchedule.minute": "",
          "WorkFlowSchedule.weekdays": "",
          "WorkFlowSchedule.cronexpression": cronExpression,
          "filter.minute": false,
          "filter.hour": false,
          "filter.date": false,
        };
        handleSubmit(obj);
        handleshowPopup(e);
        toast.success("Cron Expression Updated Successfully");
      }
    }
  };

  return (
    <div className="schedular-popup">
      <div className="popup-title">
        <h2>Scheduler</h2>
        <img
          src={close}
          alt="close"
          className="cursor-pointer"
          id="scheduler"
          onClick={(e) => {
            handleshowPopup(e);
          }}
        />
      </div>
      <div className="popup-body">
        <Row>
          <Col xl={12}>
            <Form.Group className="form-group mb10">
              <Form.Label className="common-label">
                Workflow Name<span className="ms-1 red-color-text">*</span>
              </Form.Label>

              <div className="position-relative">
                <div
                  className={`${
                    Input.errors.projectname && "error-border-line"
                  }`}
                >
                  <Form.Control
                    type="text"
                    placeholder="Workflow Name"
                    className="common-input"
                    value={Input.projectname}
                    disabled
                    onChange={(e) => {
                      const val = e.target.value;
                      // const regEx = /^[a-z0-9 ]*$/i;
                      const regEx = /^[a-z0-9\- ]*$/i;
                      const isValid = regEx.test(val);
                      if (val === "") {
                        setInput({
                          ...Input,
                          projectname: "",
                        });
                      } else if (isValid) {
                        setInput({
                          ...Input,
                          projectname: val,
                        });
                      }
                    }}
                  />
                </div>
                {Input.errors.projectname && (
                  <p className="error-line">
                    <span className="error-message-icon">
                      <img
                        src={infoIcon}
                        alt="infoIcon"
                        title={Input.errors.projectname}
                      />
                    </span>
                  </p>
                )}
              </div>
            </Form.Group>
          </Col>
          <Col xl={12}>
            <Form.Group className="form-group mb12">
              <Form.Label className="common-label">
                Time Zone<span className="ms-1 red-color-text">*</span>
              </Form.Label>

              <div className="position-relative">
                <div
                  className={`${Input.errors.timezone && "error-border-line"}`}
                >
                  <Form.Select
                    disabled={isViewMode}
                    className={
                      isViewMode ? "common-select-disabled" : "common-select"
                    }
                    value={Input?.timezone || Userdata?.timezone}
                    onChange={(e) => {
                      setInput({
                        ...Input,
                        timezone: e.target.value,
                      });
                    }}
                  >
                    <option value="">Select Timezone</option>
                    {TIMEZONE_LIST?.map((item) => {
                      return (
                        <option key={item?.value} value={item?.value}>
                          {item?.displayName}
                        </option>
                      );
                    })}
                  </Form.Select>
                </div>
              </div>
            </Form.Group>
          </Col>
          <div className="d-flex justify-content-center  align-items-center gap-3">
            <Col xl={5} style={{ width: "180px" }}>
              {/* <div className="date-time"> */}
              <Form.Label className="common-label">
                Start Date<span className="ms-1 red-color-text">*</span>
              </Form.Label>
              <div className="position-relative">
                <div
                  className={`${Input.errors.startdate && "error-border-line"}`}
                >
                  <Form.Control
                    type="date"
                    disabled={isViewMode}
                    className="common-input"
                    value={Input?.startdate}
                    onChange={(e) => {
                      if (e.target.value && Input?.enddate) {
                        dayCreationFromDates(e.target.value, Input?.enddate);
                      }
                      setInput({
                        ...Input,
                        startdate: e.target.value,
                      });
                    }}
                  />
                </div>
                {/* {Input.errors.startdate && (
                <p className="error-line">
                  <span className="error-message-icon">
                    <img
                      src={infoIcon}
                      alt="infoIcon"
                      title={Input.errors.startdate}
                    />
                  </span>
                </p>
              )} */}
              </div>

              {/* </div> */}
            </Col>
            {/* <Col xl={2}>
              <p className="text-black text-center">to</p>
            </Col> */}
            <Col xl={5} className="ps-0" style={{ width: "178px" }}>
              {/* <div className="date-time"> */}
              <Form.Label className="common-label">
                End Date<span className="ms-1 red-color-text">*</span>
              </Form.Label>

              <div className="position-relative">
                <div
                  className={`${Input.errors.enddate && "error-border-line"}`}
                >
                  <Form.Control
                    type="date"
                    disabled={isViewMode}
                    className="common-input"
                    value={Input?.enddate}
                    min={Input?.startdate}
                    onChange={(e) => {
                      if (Input?.startdate && e.target.value) {
                        dayCreationFromDates(Input?.startdate, e.target.value);
                      }
                      setInput({
                        ...Input,
                        enddate: e.target.value,
                      });
                    }}
                  />
                </div>
                {/* {Input.errors.enddate && (
                <p className="error-line">
                  <span className="error-message-icon">
                    <img
                      src={infoIcon}
                      alt="infoIcon"
                      title={Input.errors.enddate}
                    />
                  </span>
                </p>
              )} */}
              </div>

              {/* </div> */}
            </Col>
          </div>
          {/* <Col xl={12}>
            <div className="d-flex align-items-center gap-3">
              <Form.Check
                type="checkbox"
                id="default-checkbox"
                label="All Day"
              />

              <Form.Select className="common-select">
                <option>Monthly on Second Sunday</option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Form.Select>
            </div>
          </Col> */}
          {/* <Col xl={12}>
            <div className="d-flex align-items-center justify-content-between mt20">
              <Form.Label className="common-label">
                Schedule to Run Repeatedly?
              </Form.Label>
              <div className="d-flex align-items-center gap-3">
                {YES_NO_ARRAY.map((item_rr, index_rr) => (
                  <Form.Check
                    type="radio"
                    id="default-radio"
                    checked={Input.run_repeatedly.includes(item_rr)}
                    label={item_rr}
                    value={item_rr}
                    onChange={(e) => {
                      fnRunRepHandle(e);
                    }}
                  />
                ))}
              </div>
            </div>
          </Col> */}
          <Col xl={12} className="mt12">
            <div className="custom-tabing custom-tabing-in-modal ">
              <div
                className={activeTab === 0 ? "single-tab active" : "single-tab"}
                onClick={() => handleTabClick(0)}
              >
                <span>Simple</span>
              </div>
              <div
                className={activeTab === 1 ? "single-tab active" : "single-tab"}
                onClick={() => handleTabClick(1)}
              >
                <span>Crontab</span>
              </div>
            </div>
          </Col>
          {activeTab === 0 ? (
            <>
              <Col xl={12} className="mt12">
                <div
                  className="d-flex align-items-center"
                  style={{ gap: "20px" }}
                >
                  <Form.Check
                    disabled={isViewMode}
                    type="checkbox"
                    id="All Minutes"
                    label="All Minutes"
                    value="All Minutes"
                    checked={allFilter?.minute}
                    onChange={(e) => {
                      setAllFilter({
                        ...allFilter,
                        minute: e.target.checked,
                      });
                      setInput({
                        ...Input,
                        minute: [],
                      });
                    }}
                  />
                  <Form.Check
                    disabled={isViewMode}
                    type="checkbox"
                    id="All Hours"
                    label="All Hours"
                    value="All Hours"
                    checked={allFilter?.hour}
                    onChange={(e) => {
                      setAllFilter({
                        ...allFilter,
                        hour: e.target.checked,
                      });
                      setInput({
                        ...Input,
                        hour: [],
                      });
                    }}
                  />
                  <Form.Check
                    disabled={isViewMode}
                    type="checkbox"
                    id="All Dates"
                    label="All Dates"
                    value="All Dates"
                    checked={allFilter?.date}
                    onChange={(e) => {
                      setAllFilter({
                        ...allFilter,
                        date: e.target.checked,
                      });
                      setInput({
                        ...Input,
                        date: [],
                      });
                    }}
                  />
                </div>
              </Col>
              <Col xl={12} className="mt8">
                <Form.Group className="form-group">
                  <Form.Label className="common-label">
                    Minutes
                    {!allFilter?.minute && (
                      <span className="ms-1 red-color-text">*</span>
                    )}
                  </Form.Label>
                  <div
                    className={`${
                      errList.minutes &&
                      !allFilter?.minute &&
                      "error-border-line"
                    }`}
                  >
                    <Select
                      isDisabled={allFilter?.minute || isViewMode}
                      options={minuteOptions}
                      isMulti
                      value={Input?.minute}
                      onChange={(e) => {
                        handleMultiSelection(e, "minute");
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col xl={12} className="mt8">
                <Form.Group className="form-group">
                  <Form.Label className="common-label">
                    Hours
                    {!allFilter?.hour && (
                      <span className="ms-1 red-color-text">*</span>
                    )}
                  </Form.Label>
                  <div
                    className={`${
                      errList.hour && !allFilter?.hour && "error-border-line"
                    }`}
                  >
                    <Select
                      isDisabled={allFilter?.hour || isViewMode}
                      options={Hour_Options}
                      isMulti
                      value={Input?.hour}
                      onChange={(e) => {
                        handleMultiSelection(e, "hour");
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col xl={12} className="mt8">
                <Form.Group className="form-group">
                  <Form.Label className="common-label">
                    Dates
                    {!allFilter?.date && (
                      <span className="ms-1 red-color-text">*</span>
                    )}
                  </Form.Label>
                  <div
                    className={`${
                      errList.dates && !allFilter?.date && "error-border-line"
                    }`}
                  >
                    <Select
                      isDisabled={allFilter?.date || isViewMode}
                      options={dateOptions}
                      isMulti
                      value={Input?.date}
                      onChange={(e) => {
                        handleMultiSelection(e, "date");
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
              {/* <Col xl={12} className="mt16">
                <div className="d-flex align-items-center gap-2">
                  <Form.Select
                    className="common-select width75"
                    value={Input.minute}
                    onChange={(e) => {
                      setInput({
                        ...Input,
                        minute: e.target.value,
                      });
                    }}
                  >
                    {MINUTES_ARRAY.map((item_m, index_m) => (
                      <option value={item_m}>{item_m}</option>
                    ))}
                  </Form.Select>

                  <Select
                    options={Hour_Options}
                    isMulti
                    defaultValue={Input?.hour}
                    onChange={(e) => {
                      let temp = [];
                      e.forEach((element) => {
                        temp.push(element?.value);
                      });
                      setInput({
                        ...Input,
                        hour: temp,
                      });
                    }}
                  />
                </div>
              </Col> */}
              <Col xl={12} className="mt12">
                <div className="checkbox-list-in-modal">
                  <div>
                    {DayList?.length > 0 && (
                      <>
                        <Form.Check
                          disabled={isViewMode}
                          type="checkbox"
                          id="Every Day"
                          label="Every Day"
                          value="Every Day"
                          onChange={(e) => {
                            fnDayHandle(e);
                          }}
                          checked={SelectedDayList.length === DayList.length}
                        />
                        {DayList?.map((item_d, index_d) => (
                          <Form.Check
                            disabled={isViewMode}
                            type="checkbox"
                            id={item_d}
                            label={item_d}
                            value={item_d}
                            checked={SelectedDayList.includes(
                              DAY_MAPPING[item_d]
                            )}
                            onChange={(e) => {
                              fnDayHandle(e);
                            }}
                          />
                        ))}
                      </>
                    )}
                  </div>
                  <div>
                    {MonthList?.length > 0 && (
                      <>
                        <Form.Check
                          type="checkbox"
                          disabled={isViewMode}
                          id="Every Month"
                          label="Every Month"
                          value="Every Month"
                          checked={
                            SelectedMonthList.length === MonthList.length
                          }
                          onChange={(e) => {
                            fnMonthHandle(e);
                          }}
                        />
                        {MonthList?.map((item_m, index_m) => (
                          <Form.Check
                            disabled={isViewMode}
                            type="checkbox"
                            id={item_m}
                            label={item_m}
                            value={item_m}
                            checked={SelectedMonthList.includes(
                              parseInt(MONTH_MAPPING[item_m]) + 1
                            )}
                            onChange={(e) => {
                              fnMonthHandle(e);
                            }}
                          />
                        ))}
                      </>
                    )}
                  </div>
                </div>
              </Col>
              {/* <Col xl={8}>
                <div className="d-flex align-items-center justify-content-between mt20">
                  <Form.Label className="common-label">
                    Enable Scheduling?
                  </Form.Label>
                  <div className="d-flex align-items-center gap-3">
                    {YES_NO_ARRAY.map((item_rr, index_rr) => (
                      <Form.Check
                        type="radio"
                        id="default-radio"
                        checked={Input.enable_scheduling.includes(item_rr)}
                        label={item_rr}
                        value={item_rr}
                        onChange={(e) => {
                          fnEnableShedulingHandle(e);
                        }}
                      />
                    ))}
                  </div>
                </div>
              </Col> */}
              {/* <Col xl={8}>
                <div className="d-flex align-items-center justify-content-between mt14">
                  <Form.Label className="common-label">
                    Enable Execution?
                  </Form.Label>
                  <div className="d-flex align-items-center gap-3">
                    {YES_NO_ARRAY.map((item_rr, index_rr) => (
                      <Form.Check
                        type="radio"
                        id="default-radio"
                        checked={Input.enable_execution.includes(item_rr)}
                        label={item_rr}
                        value={item_rr}
                        onChange={(e) => {
                          fnEnableExecutionHandle(e);
                        }}
                      />
                    ))}
                  </div>
                </div>
              </Col> */}
            </>
          ) : (
            <>
              <Col xl={12} className="mt16">
                <textarea
                  type="text"
                  rows={2}
                  disabled={isViewMode}
                  placeholder="000?***"
                  className="common-input"
                  value={cronExpression}
                  onChange={(e) => {
                    setCronExpression(e.target.value);
                  }}
                />
                <div className="all-critarias">
                  <div className="d-flex align-items-center gap-4">
                    <p>
                      Ranges: <span>1-3</span>
                    </p>
                    <p>
                      Lists: <span>1,4,6</span>
                    </p>
                    <p>
                      Increments: <span>0/15</span>
                    </p>
                  </div>
                  <p className="mt8">
                    Valid values of Day of Week: 1-7 or SUN-SAT
                  </p>
                  <p className="mt8">Valid values of Month: 1-12 or JAN-DEC</p>
                </div>
              </Col>
              {/* <Col xl={8}>
                <div className="d-flex align-items-center justify-content-between mt14">
                  <Form.Label className="common-label">
                    Enable Execution?
                  </Form.Label>
                  <div className="d-flex align-items-center gap-2">
                    <Form.Check type="radio" id="default-radio1" label="No" />
                    <Form.Check type="radio" id="default-radio2" label="Yes" />
                  </div>
                </div>
              </Col> */}
            </>
          )}
        </Row>
      </div>
      <div className="popup-footer">
        <button className="grey-btn" onClick={handleshowPopup}>
          Cancel
        </button>
        <button
          disabled={isViewMode}
          className={isViewMode ? "disable-blue-btn" : "blue-btn"}
          onClick={async (e) => {
            handleSubmitScheduler();
          }}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default SchedularPopup;
